import React from 'react';
import Comments from '../../../../Elements/Comments';
import AttachmentsComponent from '../../../../Elements/AttachmentsComponent';
import LogComponent from '../../../../Elements/LogComponent';
import TabbedPage from '../../../../Elements/TabbedPage';
import ClientInvoiceDetailsInfoTab from './ClientInvoiceDetailsInfoTab';
import TaxComponent from '../../../../Elements/TaxComponent';
import ClientInvoiceDetailsDetailsTab from './ClientInvoiceDetailsDetailsTab';
import ClientInvoiceService from '../../../../Services/ClientInvoiceService';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import ClientInvoiceCreditMemosTab from './ClientInvoiceCreditMemosTab';
import InvoicePdfPreviewComponent from '../../../../Elements/InvoicePdfPreviewComponent';
import ClientInvoiceViewDescription from './ClientInvoiceViewDescription';
import dateTimeHelper from '../../../../Helpers/datetimeHelper';
import ClientInvoicePaymentsAppliedTabs from './ClientInvoicePaymentsAppliedTabs';

export default class ClientInvoiceDetails extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      officeId: 0,
      fileName: '',
    };
  }

  urlParams = new URLSearchParams(window.location.search);
  clientInvoiceId = this.urlParams.get('id');

  componentDidMount() {
    ClientInvoiceService.GetByInvoiceId(this.clientInvoiceId)
      .then((res) => {
        if (res.error) {
          ErrorMessage.SetErrorMessage(res.error);
          return;
        }
        this.setState({
          officeId: res.officeId,
          fileName: `BARE_Invoice-${res.ciId}-${res.ciBillToClientName}-${dateTimeHelper.getFormattedDate(
            new Date(res.ciDate),
            '-'
          )}`,
        });
      })
      .catch((error) => ErrorMessage.SetErrorMessage('CID28', error));
  }

  static getMenuText() {
    const id = new URLSearchParams(window.location.search).get('id');
    return `Client Invoice ${id ? '- ' + id : 'Details'}`;
  }

  tabs = () => [
    {
      label: 'Information',
      id: 'info',
      icon: 'fa-solid fa-info',
      component: <ClientInvoiceDetailsInfoTab clientInvoiceId={this.clientInvoiceId} />,
    },
    {
      label: 'Invoice Details',
      id: 'details',
      icon: 'fa-solid fa-file-invoice',
      component: <ClientInvoiceDetailsDetailsTab clientInvoiceId={this.clientInvoiceId} />,
    },
    {
      label: 'Invoice View',
      id: 'view',
      icon: 'fa-solid fa-eye',
      component: (
        <InvoicePdfPreviewComponent
          id={this.clientInvoiceId}
          invoiceDescription={ClientInvoiceViewDescription}
          attachRoleKey='clientinvoice_attachpdfbutton'
          excelWordRoleKey='clientinvoice_excelwordbutton'
          downloadFileName={this.state.fileName}
          hideSearchStrip={true}
        />
      ),
    },
    {
      label: 'Payments Applied',
      id: 'paymentsapplied',
      icon: 'fa-solid fa-check',
      component:  <ClientInvoicePaymentsAppliedTabs tpClientInvoiceId={this.clientInvoiceId} />
    },
    {
      label: 'Credit Memos',
      id: 'creditmemos',
      icon: 'fa-solid fa-credit-card',
      component: <ClientInvoiceCreditMemosTab clientInvoiceId={this.clientInvoiceId} />,
    },
    {
      label: 'Taxes',
      id: 'taxes',
      icon: 'fa-solid fa-percent',
      component: (
        <TaxComponent
          entityTypeId={28}
          entityId={this.clientInvoiceId ? parseInt(this.clientInvoiceId) : null}
          isActiveSlide={false}
          showEdit={false}
          showAddNewTaxLink={false}
          officeId={this.state.officeId}
          showRemove={false}
        />
      ),
    },
    {
      label: 'Comments',
      id: 'comments',
      icon: 'fa-solid fa-comment',
      component: (
        <Comments
          entityTypeId={28}
          entityId={this.clientInvoiceId}
        />
      ),
    },
    {
      label: 'Attachments',
      id: 'attachments',
      icon: 'fa-solid fa-paperclip',
      component: (
        <AttachmentsComponent
          entityTypeId={28}
          entityId={this.clientInvoiceId}
          enableAddNew={true}
        />
      ),
    },
    {
      label: 'Logs',
      id: 'logs',
      icon: 'fa-solid fa-stream',
      component: (
        <LogComponent
          entityType='ClientInvoice'
          entityId={this.clientInvoiceId}
        />
      ),
    },
  ];

  render() {
    return (
      <div className='contentwrapper'>
        <TabbedPage tabs={this.tabs()} />
      </div>
    );
  }
}
